import { type AcceptQuotePayload } from '../../../modules/moves'
import { type CheckoutFormValues } from './CheckoutForm.type'

export const formatFormOutput = (values: CheckoutFormValues): AcceptQuotePayload => {
  return {
    movingTime: values.movingTime,
    note: values.note !== '' ? values.note : undefined,
  }
}
